import styled from '@emotion/styled';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: fit-content;
  flex-wrap: wrap;
  justify-content: space-between;
  background: #dddddd30;
  padding: 10px;
  font-size: 14px;
  border-radius: 16px;
  font-weight: 500;

  b {
    display: block;
    font-size: 18px;
    color: ${({ theme }) => theme.colors.primary};
    font-weight: bold;
  }
`;

export const Summary = styled.div`
  position: relative;
  text-align: left;
  padding: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  & + & {
    border-top: solid 1px #ddd;
  }

  .paymentDate {
    margin-top: 20px;
  }

  &.account {
    width: 100%;
    flex: auto;
    margin-top: 2em;
    text-align: center;
    border: 0;

    strong {
      margin-top: 1em;
    }
  }

  .info-text {
    font-size: 12px;
    font-weight: normal;
  }

  .payment-value {
    &--refund {
      color: ${({ theme }) => theme.colors.error};
    }
  }

  button {
    width: auto;
    margin: 0 15px 0 auto;
  }

  .text {
    &--xl {
      font-size: 18px;
    }
  }
`;

export const BankDetails = styled.div`
  margin-top: 10px;
  text-align: center;
  font-weight: normal;
  line-height: 30px;
`;
